import {createBrowserHistory} from 'history'
import ReactGA from 'react-ga';

export const History = createBrowserHistory()
History.listen((location)=>{
    ReactGA.pageview(location.pathname);
})